import React from 'react';
import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/20/solid';
import { SkeletonField } from 'components/layout/loading';
import BaseTextInput from '../BaseTextInput/BaseTextInput';
import InputLabel from '../InputLabel/InputLabel';

export default function SearchInput({
  id = 'search',
  label = 'Search',
  value = '',
  onChange,
  placeholder = 'Search',
  className = 'w-full',
  loading = false,
  disabled = false,
  onClear,
  ...props
}) {
  if (loading) {
    return <SkeletonField className={className} />;
  }

  const hasValue = Boolean(value);

  const handleClear = () => {
    if (onClear) {
      onClear();
      return;
    }

    if (onChange) {
      onChange({ target: { value: '' } });
    }
  };

  return (
    <div className={className}>
      {label && <InputLabel htmlFor={id}>{label}</InputLabel>}
      <div className="relative mt-2">
        <span className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400">
          <MagnifyingGlassIcon className="h-4 w-4" aria-hidden="true" />
        </span>
        <BaseTextInput
          id={id}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          className="pl-9 pr-9"
          {...props}
        />
        {hasValue && (
          <button
            type="button"
            aria-label="Clear search"
            onMouseDown={(event) => event.preventDefault()}
            onClick={handleClear}
            disabled={disabled}
            className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 transition hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500 disabled:cursor-not-allowed disabled:opacity-50 cursor-pointer"
          >
            <XMarkIcon className="h-4 w-4" aria-hidden="true" />
          </button>
        )}
      </div>
    </div>
  );
}
